import React from 'react';
import { useQuery } from '@apollo/client';
import TrackerQuery from './TrackerQuery';

type result = {
  loading: boolean;
  trackerData?: any;
  aiAccess?: boolean;
  dietAccess?: boolean;
};

interface ITrackerConnectorApolloProps {
  children: (result: result) => React.ReactElement;
  date: string;
}

export const TrackerConnectorApollo: React.FC<ITrackerConnectorApolloProps> = ({
  children,
  date,
}) => {
  const { loading, data, error } = useQuery(TrackerQuery, {
    variables: {
      date,
    },
  });

  const result: result = {
    loading,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    const todayDateString = new Date().toISOString().slice(0, 10);
    const dietAccessTo = data.me?.diet?.accessTo;
    const hasDietAccess = Boolean(dietAccessTo) && dietAccessTo >= todayDateString;
    result.trackerData = data.dailyTracker.data;
    result.aiAccess = data.me.aiAccess.hasAccess;
    result.dietAccess = hasDietAccess;
  }

  return children(result);
};

export default TrackerConnectorApollo;
